const Dashboard = () => import("@/views/Dashboard");
const Tables = () => import("@/views/base/Tables");
const MapByState = () => import("@/views/base/MapState");
const City = () => import("@/views/base/city.vue");
const TodoList = () => import("@/views/base/TodoList.vue");
const TodoCalendar = () => import("@/views/base/ToDoCalendar.vue");
const TodoListDetails = () => import("@/views/base/TodoListDetails.vue");
const TableAllData = () => import("@/views/base/TableAllData.vue");
const TableAllDataC = () => import("@/views/base/TableAllDataC.vue");
const AccountsReceivables = () =>
  import("@/views/base/AccountsReceivables.vue");
const AccountsReceivablesDetails = () =>
  import("@/views/base/AccountsReceivablesDetails.vue");
const Map = () => import("@/views/base/Map.vue");

const generalRoutes = {
  mainRoute: "dashboard",
  children: [
    {
      path: "dashboard",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "base/Tables",
      name: "Tables",
      component: Tables,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/TableAllData",
      name: "TableAllData",
      component: TableAllData,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/TableAllDataC",
      name: "TableAllDataC",
      component: TableAllDataC,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/city",
      name: "City",
      component: City,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/MapByState",
      name: "MapByState",
      component: MapByState,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/TodoList",
      name: "TodoList",
      component: TodoList
    },
    {
      path: "base/TodoListIT",
      name: "TodoListIT",
      component: TodoList
    },
    {
      path: "base/todo-calendar",
      name: "todoCalendar",
      component: TodoCalendar
    },
    {
      path: "base/TodoList-Details",
      name: "TodoListDetails",
      component: TodoListDetails,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/AccountsReceivables",
      name: "AccountsReceivables",
      component: AccountsReceivables
    },
    {
      path: "base/AccountsReceivables-details",
      name: "AccountsReceivablesDetails",
      component: AccountsReceivablesDetails,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/Map",
      name: "Map Overview",
      component: Map
    }
  ]
};

export default generalRoutes;
